"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComparisonPositionEnum = void 0;
var ComparisonPositionEnum;
(function (ComparisonPositionEnum) {
    ComparisonPositionEnum["BEHIND"] = "BEHIND";
    ComparisonPositionEnum["EQUAL"] = "EQUAL";
    ComparisonPositionEnum["AHEAD"] = "AHEAD";
})(ComparisonPositionEnum || (exports.ComparisonPositionEnum = ComparisonPositionEnum = {}));
